import { render, staticRenderFns } from "./appSelection.vue?vue&type=template&id=47e2852c&scoped=true"
import script from "./appSelection.vue?vue&type=script&lang=js"
export * from "./appSelection.vue?vue&type=script&lang=js"
import style0 from "./appSelection.vue?vue&type=style&index=0&id=47e2852c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e2852c",
  null
  
)

export default component.exports